import { z } from "zod";

export const closeMissionSchema = (t: (key: string) => string) =>
  z.object({
    statusComment: z.string().nonempty(t("global.form.error.mandatoryField")),
  });
export type CloseMissionFormValues = z.infer<ReturnType<typeof closeMissionSchema>>;
